// ============================================================================
// ENGLISH TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// Fun but thoughtful questions

export const funQuestions = [
  {
    question: "If Jesus had a phone, who would be his first contact?",
    emoji: "📱",
    theme: "divine_relationship"
  },
  {
    question: "Why did David never lose his sheep?",
    emoji: "🐑", 
    theme: "shepherd"
  },
  {
    question: "How much does God's love cost?",
    emoji: "💰",
    theme: "grace"
  },
  {
    question: "What's the difference between God's peace and a nap?",
    emoji: "😴",
    theme: "peace"
  },
  {
    question: "Why does God's Word never run out of battery?",
    emoji: "🔋",
    theme: "word"
  },
  {
    question: "If Moses had GPS, would he have wandered 40 years in the desert?",
    emoji: "🗺️",
    theme: "guidance"
  },
  {
    question: "Why do angels never need to exercise?",
    emoji: "👼",
    theme: "perfection"
  },
  {
    question: "What would Solomon say about modern social media?",
    emoji: "📱",
    theme: "wisdom"
  }
];

export default funQuestions;